import { useEffect, useState } from "react";
import { cx } from "./cx";
import styles from "./Logo.module.css";

export type LogoProps = {
  /** URL versionnée du logo, ou nul : le sigle prend le relais. */
  src: string | null | undefined;
  /** Nom dont on tire le sigle, et qui sert de texte de repli. */
  name: string;
  size?: "sm" | "md" | "lg";
  className?: string;
};

/** Deux premières lettres significatives d'un nom : « ACME SAS » → « AS ». */
export function sigleDe(name: string): string {
  const mots = name
    .trim()
    .split(/\s+/)
    .filter((m) => m.length > 0);
  if (mots.length === 0) {
    return "?";
  }
  if (mots.length === 1) {
    return mots[0].slice(0, 2).toUpperCase();
  }
  return (mots[0][0] + mots[1][0]).toUpperCase();
}

/**
 * Logo d'une entreprise, ou son sigle en repli.
 *
 * L'image vient toujours du serveur, jamais d'un `data:` composé côté client ;
 * si elle ne se charge pas (logo retiré, session tombée), on retombe sur le
 * sigle plutôt que sur l'icône d'image cassée du navigateur.
 */
export function Logo({ src, name, size = "md", className }: LogoProps) {
  const [cassee, setCassee] = useState(false);
  useEffect(() => setCassee(false), [src]);

  if (src && !cassee) {
    return (
      <img
        className={cx(styles.logo, styles[size], className)}
        src={src}
        alt=""
        onError={() => setCassee(true)}
      />
    );
  }
  return (
    <span className={cx(styles.sigle, styles[size], className)} aria-hidden="true">
      {sigleDe(name)}
    </span>
  );
}
